import script from "./tipologiaFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./tipologiaFilter.vue?vue&type=script&setup=true&lang=js"

import "./tipologiaFilter.vue?vue&type=style&index=0&id=1502d923&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1502d923"]])

export default __exports__